import { useSelector } from 'react-redux'
import SpecificationsTable from './SpecificationsTable'
import { formatCurrency } from '../utils/money'
import BikeImageWatermark from './BikeImageWatermark'
import { t } from '../utils/i18n'
import BikeImage from './BikeImage'
import { getBaseModel, getSpecifications } from '../utils/bike-schema'
import { getOrderStatement } from '../utils/bike-config'

const DisplayPdf = () => {
  const { bikeConfig, lang, quantity, currencyCode, isPdfBikeOnlyLayout } =
    useSelector((state) => state)

  const baseModel = getBaseModel(bikeConfig.baseModelId)
  const bikeName = baseModel.name.en
  const specificationArray = getSpecifications(bikeConfig, lang)
  const statement = getOrderStatement(bikeConfig, quantity, currencyCode)

  const customizerLink = `https://velorbis.${
    currencyCode === 'DKK' ? 'dk' : 'eu'
  }/customizer/${window.location.search}`

  if (isPdfBikeOnlyLayout) {
    return (
      <div className="velorbis-pdf-only-view">
        <BikeImage
          isPdfBikeOnlyLayout={isPdfBikeOnlyLayout}
          background={bikeConfig.background}
        />
      </div>
    )
  }

  return (
    <div className="velorbis-pdf-view">
      <div className="velorbis-pdf-view__inline">
        <BikeImageWatermark
          baseModelId={bikeConfig.baseModelId}
          className="watermark-pdf"
          pdf
        />
        <BikeImage background={bikeConfig.background} />
        <div className="velorbis-pdf-view__price-container">
          <div className="velorbis-pdf-view__total-price">
            Total price:{' '}
            <em>{formatCurrency(statement.unitPrice, currencyCode)}</em>
          </div>

          <div className="velorbis-pdf-view__price-vat">
            {t(
              bikeConfig.baseModelId.includes('cargo')
                ? 'price_vat_cargo'
                : 'price_vat'
            )}
          </div>
        </div>
      </div>
      <div className="velorbis-pdf-view__bike-title">{bikeName}</div>
      <SpecificationsTable specificationArray={specificationArray} />
      <div className="velorbis-pdf-view__link">
        Link to bicycle in online design tool{' '}
        <a href={customizerLink}>click here</a>
      </div>
    </div>
  )
}

export default DisplayPdf
